import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Divider, FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import Button from "sushiweb/Button";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getZone, getZoneList } from "../../../store/actions/Zone";

import { getCarriersList } from "../../../store/actions/Carriers";
import Input from "sushiweb/InputTypes/Input";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { getSlotsList, resetStateSlot } from "../../../store/actions/Slots";
import {
  filterObj,
  isMobile,
  isObjectAllEntriesPresent,
  isObjectStateEmpty,
  isValNull,
  removeEmptyVals,
} from "../../../utils";
import moment from "moment";
import { getCity, getCityList } from "../../../store/actions/City";

const entityTypeList = [
  { entity_type: "Zone", id: 0 },
  { entity_type: "Store", id: 1 },
  { entity_type: "Instant Store", id: 2 },
  { entity_type: "Veg Fleet Zone", id: 3 },
  { entity_type: "Express", id: 4 },
];

const SlotsFilterInput = ({
  getZonesList,
  getSlotsList,
  nextPageZone,
  getZone,
  carriersList,
  getCarriersList,
  activeFilters,
  resetState,
  getCityList,
  getCity,
  cityList,
  nextPageCity,
}) => {
  const [initialState, setInitialState] = useState({
    carrier_type: "",
    city_id: "",
    date: "",
    entity_type: "",
    entity_id: "",
  });
  const [clearEntity, setClearEntity] = useState(false);
  const [clearCity, setClearCity] = useState(false);
  const [zonePriorityFlag, setZonePriorityFlag] = useState(false);

  const handleChange = (key, val) => {
    const values = { ...initialState };
    if (key === "city_id" || key === "entity_type") {
      setZonePriorityFlag(true);
      values["entity_id"] = "";
    } else if (key === "entity_id") {
      setZonePriorityFlag(false);
      val = parseInt(val);
    }
    values[key] = val;
    setInitialState(values);
  };

  const getValue = (key, val) => {
    if (key === "carrier") {
      const activeCarrier = carriersList.find((item) => item.id === val);
      return activeCarrier ? activeCarrier.carrier_type : "";
    } else if (key === "entity") {
      const activeEntityType = entityTypeList.find((item) => item.id === val);
      return activeEntityType ? activeEntityType.entity_type : "";
    } else {
      return val;
    }
  };

  const handleFiltersSubmit = (e, type) => {
    e.preventDefault();
    if (checkIfButtonDisabled("apply")) {
      return;
    }
    if (type === "apply") {
      const newState = removeEmptyVals(initialState);
      if (newState["date"]) {
        newState["date"] = moment(newState["date"]);
      }
      getSlotsList(newState, "removeCityId");
    } else {
      setZonePriorityFlag(false);
      setClearCity(true);
      setClearEntity(true);
      resetState({ state: "activeFilters" });
      resetState({ state: "slotsList" });
    }
  };

  const getModalState = () => {
    if (Object.keys(activeFilters).length > 0) {
      return "Edit";
    } else {
      return "Filter";
    }
  };

  const checkIfButtonDisabled = (type) => {
    if (type === "apply") {
      return !isObjectAllEntriesPresent(
        filterObj(initialState, [
          "entity_type",
          "entity_id",
          "carrier_type",
          "date",
        ])
      );
    } else {
      return isObjectStateEmpty(activeFilters);
    }
  };

  useEffect(() => {
    carriersList.length == 0 && getCarriersList();
  }, []);

  useEffect(() => {
    if (Object.keys(activeFilters).length === 0) {
      setClearCity(false);
      setClearEntity(false);
    }
    if (!isValNull(activeFilters.entity_id)) {
      setZonePriorityFlag(true);
    }
    setInitialState({
      entity_id: !isValNull(activeFilters.entity_id)
        ? activeFilters.entity_id
        : "",
      city_id: !isValNull(activeFilters.city_id) ? activeFilters.city_id : "",
      carrier_type: !isValNull(activeFilters.carrier_type)
        ? activeFilters.carrier_type
        : "",
      date: !isValNull(activeFilters.date)
        ? moment(activeFilters.date).format("YYYY-MM-DD")
        : "",
      entity_type: !isValNull(activeFilters.entity_type)
        ? activeFilters.entity_type
        : "",
      entity_id: !isValNull(activeFilters.entity_id)
        ? activeFilters.entity_id
        : "",
    });
  }, [activeFilters]);

  return (
    <SlotsFilterInputHolder onSubmit={(e) => handleFiltersSubmit(e, "apply")}>
      <h3 className="medium">FILTERS</h3>
      <Divider />
      <InputsList>
        <InfiniteScrollDropdown
          id="cityIDSelectionDropdown"
          className="sushi-dropdown"
          priorityFlag={true}
          appliedFilters={{}}
          getActiveList={getCityList}
          nextPage={nextPageCity}
          resKey="cities"
          modalState={getModalState()}
          keyName="city_id"
          labelKey="city_name"
          getDataLabelKey="city.city_name"
          keyTypeToSet="id"
          label="City"
          handleChange={handleChange}
          remoteSearchApplicable={true}
          remoteSearchKey="startswith"
          activeElement={initialState}
          getActiveItemById={getCity}
          shouldClear={clearCity}
        />
        <PaginatedReactDropdown
          options={entityTypeList}
          labelKey="entity_type"
          valueKey="id"
          id="entity_type_dropdown"
          optionsBoxId="entity_type_options_box"
          value={getValue("entity", initialState["entity_type"])}
          handleChange={handleChange}
          keyToChange="entity_type"
          placeholder="Select Entity Type"
          showCross
        />
        {initialState["entity_type"] === 1 ||
          initialState["entity_type"] === 2 ? (
          <Input
            value={initialState["entity_id"]}
            type="number"
            id="sushi-input"
            onChange={(e) => handleChange("entity_id", e)}
            label="Store Id"
            data-testId="store_id"
          />
        ) : null}
        {initialState["entity_type"] === 0 ||
          initialState["entity_type"] === 3 || initialState["entity_type"] === 4 ? (
          <InfiniteScrollDropdown
            id="zoneIDSelectionDropdown"
            className="sushi-dropdown"
            priorityFlag={zonePriorityFlag}
            setPriorityFlag={setZonePriorityFlag}
            appliedFilters={
              initialState && initialState.city_id
                ? { city_id: initialState.city_id }
                : {}
            }
            getActiveList={getZonesList}
            nextPage={nextPageZone}
            resKey="zones"
            modalState={getModalState()}
            keyName="entity_id"
            labelKey="zone_name"
            getDataLabelKey="zone.zone_name"
            keyTypeToSet="id"
            label="Select Zone"
            handleChange={handleChange}
            remoteSearchApplicable={true}
            remoteSearchKey="startswith"
            activeElement={initialState}
            getActiveItemById={getZone}
            activeFilters={activeFilters}
            shouldClear={clearEntity}
          />
        ) : null}
        <PaginatedReactDropdown
          options={carriersList}
          labelKey="carrier_type"
          valueKey="id"
          labelWidth="35%"
          id="carrier_slot_dropdown"
          optionsBoxId="carrier_slot_options_box"
          value={getValue("carrier", initialState["carrier_type"])}
          handleChange={handleChange}
          keyToChange="carrier_type"
          placeholder="Select Carrier"
          showCross
        />
        <Input
          id="sushi-input"
          value={
            (initialState.date &&
              moment(initialState.date).format("YYYY-MM-DD")) ||
            " "
          }
          fullWidth={true}
          label="Enter Date"
          type="date"
          onChange={(val) => handleChange("date", val)}
        />
        <FlexContainer>
          <Button
            onClick={(e) => handleFiltersSubmit(e, "clear")}
            disabled={checkIfButtonDisabled("Clear")}
            data-testid="SlotsFilterClear"
            className="sushi-btn mr-10"
            appearance="outline"
          >
            Clear
          </Button>
          <Button
            className="sushi-btn"
            disabled={checkIfButtonDisabled("apply")}
            data-testid="SlotsFiltersApply"
            type="submit"
          >
            Apply
          </Button>
        </FlexContainer>
      </InputsList>
    </SlotsFilterInputHolder>
  );
};

const SlotsFilterInputHolder = styled.form`
  background: ${variables.white};
  border: 0.5px solid ${variables.grey300};
  box-sizing: border-box;
  border-radius: 8px;
  margin-right: 20px;
  width: ${isMobile() ? "100%" : "30%"};
  margin-bottom: ${isMobile() ? "20px" : "unset"};
  h3 {
    margin: unset;
    padding: 18px;
    color: ${variables.grey700};
  }
`;

const InputsList = styled.div`
  padding: 18px;
`;

function mapStateToProps(state) {
  const { Zone, Carriers, Slots, City } = state;
  return {
    zoneList: Zone.zoneList,
    nextPageZone: Zone.nextPage,
    carriersList: Carriers.carriersList,
    activeFilters: Slots.activeFilters,
    cityList: City.cityList,
    nextPageCity: City.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getZonesList: bindActionCreators(getZoneList, dispatch),
    getZone: bindActionCreators(getZone, dispatch),
    getCarriersList: bindActionCreators(getCarriersList, dispatch),
    getSlotsList: bindActionCreators(getSlotsList, dispatch),
    resetState: bindActionCreators(resetStateSlot, dispatch),
    getCity: bindActionCreators(getCity, dispatch),
    getCityList: bindActionCreators(getCityList, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SlotsFilterInput);
